import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api";
import { useAuth } from "@/lib/auth";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/admin/login"); return; }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.get(`/auth/google?session_id=${encodeURIComponent(sessionId)}`);
        // Store token for future Authorization headers (cookies are blocked by ingress CORS)
        const { setToken } = await import("@/api");
        if (r.data?.session_token) setToken(r.data.session_token);
        
        // Refresh the auth state so components like AdminLayout see the logged-in user
        await refresh();

        if (r.data?.is_admin) {
          window.history.replaceState(null, "", "/admin");
          navigate("/admin", { replace: true, state: { user: r.data } });
        } else {
          navigate("/admin/login?denied=1", { replace: true });
        }
      } catch (e) {
        navigate("/admin/login?error=1", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen bg-[#1C1C1C] flex items-center justify-center text-white font-body">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-[#C1121F] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-white/70">Signing you in…</p>
      </div>
    </div>
  );
}
